import {
  Companion_getInstance1am9aucrot1gq as Companion_getInstance,
  CompletionRequest2ew7c02dda2ep as CompletionRequest,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareCompletionRequestFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [CompletionRequest_contractor_getInstance(), CompletionRequest_requestSummary_getInstance(), CompletionRequest_files_getInstance(), CompletionRequest_customer_getInstance(), CompletionRequest_autoRelease_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function CompletionRequest_contractor$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function CompletionRequest_contractor$_get_name_$ref_v8kgya() {
  return (p0) => p0.k20();
}
function CompletionRequest_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionRequest_contractor$_get_serializer_$ref_vep4bv() {
  return (p0) => p0.j2j();
}
function CompletionRequest_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function CompletionRequest_contractor$_get_annotations_$ref_y5gy0p() {
  return (p0) => p0.bz();
}
var CompletionRequest_contractorClass;
function CompletionRequest_contractor() {
  if (CompletionRequest_contractorClass === VOID) {
    class $ {
      constructor() {
        CompletionRequest_contractor_instance = this;
        var tmp = this;
        tmp.p5f_1 = lazy(CompletionRequest_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q5f_1 = lazy(CompletionRequest_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r5f_1 = lazy(CompletionRequest_contractor$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.p5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionRequest_contractor$_get_name_$ref_v8kgya(), null);
        return tmp0.f2();
      }
      s5f(receiver) {
        return receiver.t5f_1;
      }
      m2j(receiver) {
        return this.s5f(receiver instanceof CompletionRequest() ? receiver : THROW_CCE());
      }
      y5f(receiver, value) {
        return receiver.z5f(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionRequest() ? receiver : THROW_CCE();
        return this.y5f(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionRequest_contractor$_get_serializer_$ref_vep4bv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionRequest_contractor$_get_annotations_$ref_y5gy0p(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionRequest_contractor', VOID, VOID, [SerializableProperty()]);
    CompletionRequest_contractorClass = $;
  }
  return CompletionRequest_contractorClass;
}
var CompletionRequest_contractor_instance;
function CompletionRequest_contractor_getInstance() {
  if (CompletionRequest_contractor_instance === VOID)
    new (CompletionRequest_contractor())();
  return CompletionRequest_contractor_instance;
}
function CompletionRequest_requestSummary$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function CompletionRequest_requestSummary$_get_name_$ref_h7pixc() {
  return (p0) => p0.k20();
}
function CompletionRequest_requestSummary$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionRequest_requestSummary$_get_serializer_$ref_r9p99z() {
  return (p0) => p0.j2j();
}
function CompletionRequest_requestSummary$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function CompletionRequest_requestSummary$_get_annotations_$ref_933eed() {
  return (p0) => p0.bz();
}
var CompletionRequest_requestSummaryClass;
function CompletionRequest_requestSummary() {
  if (CompletionRequest_requestSummaryClass === VOID) {
    class $ {
      constructor() {
        CompletionRequest_requestSummary_instance = this;
        var tmp = this;
        tmp.a5g_1 = lazy(CompletionRequest_requestSummary$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b5g_1 = lazy(CompletionRequest_requestSummary$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c5g_1 = lazy(CompletionRequest_requestSummary$annotations$delegate$lambda);
        this.d5g_1 = '';
        this.e5g_1 = '""';
      }
      k20() {
        var tmp0 = this.a5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionRequest_requestSummary$_get_name_$ref_h7pixc(), null);
        return tmp0.f2();
      }
      s5f(receiver) {
        return receiver.u5f_1;
      }
      m2j(receiver) {
        return this.s5f(receiver instanceof CompletionRequest() ? receiver : THROW_CCE());
      }
      f5g(receiver, value) {
        return receiver.z5f(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionRequest() ? receiver : THROW_CCE();
        return this.f5g(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionRequest_requestSummary$_get_serializer_$ref_r9p99z(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionRequest_requestSummary$_get_annotations_$ref_933eed(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionRequest_requestSummary', VOID, VOID, [SerializableProperty()]);
    CompletionRequest_requestSummaryClass = $;
  }
  return CompletionRequest_requestSummaryClass;
}
var CompletionRequest_requestSummary_instance;
function CompletionRequest_requestSummary_getInstance() {
  if (CompletionRequest_requestSummary_instance === VOID)
    new (CompletionRequest_requestSummary())();
  return CompletionRequest_requestSummary_instance;
}
function CompletionRequest_files$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function CompletionRequest_files$_get_name_$ref_s4u0d4() {
  return (p0) => p0.k20();
}
function CompletionRequest_files$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionRequest_files$_get_serializer_$ref_bx7xxb() {
  return (p0) => p0.j2j();
}
function CompletionRequest_files$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function CompletionRequest_files$_get_annotations_$ref_ujz0bh() {
  return (p0) => p0.bz();
}
var CompletionRequest_filesClass;
function CompletionRequest_files() {
  if (CompletionRequest_filesClass === VOID) {
    class $ {
      constructor() {
        CompletionRequest_files_instance = this;
        var tmp = this;
        tmp.g5g_1 = lazy(CompletionRequest_files$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h5g_1 = lazy(CompletionRequest_files$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i5g_1 = lazy(CompletionRequest_files$annotations$delegate$lambda);
        this.j5g_1 = emptyList();
        this.k5g_1 = 'emptyList()';
      }
      k20() {
        var tmp0 = this.g5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionRequest_files$_get_name_$ref_s4u0d4(), null);
        return tmp0.f2();
      }
      s5f(receiver) {
        return receiver.v5f_1;
      }
      m2j(receiver) {
        return this.s5f(receiver instanceof CompletionRequest() ? receiver : THROW_CCE());
      }
      l5g(receiver, value) {
        return receiver.z5f(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionRequest() ? receiver : THROW_CCE();
        return this.l5g(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionRequest_files$_get_serializer_$ref_bx7xxb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionRequest_files$_get_annotations_$ref_ujz0bh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionRequest_files', VOID, VOID, [SerializableProperty()]);
    CompletionRequest_filesClass = $;
  }
  return CompletionRequest_filesClass;
}
var CompletionRequest_files_instance;
function CompletionRequest_files_getInstance() {
  if (CompletionRequest_files_instance === VOID)
    new (CompletionRequest_files())();
  return CompletionRequest_files_instance;
}
function CompletionRequest_customer$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function CompletionRequest_customer$_get_name_$ref_2eeunr() {
  return (p0) => p0.k20();
}
function CompletionRequest_customer$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionRequest_customer$_get_serializer_$ref_pd6sv2() {
  return (p0) => p0.j2j();
}
function CompletionRequest_customer$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function CompletionRequest_customer$_get_annotations_$ref_l4bbj2() {
  return (p0) => p0.bz();
}
var CompletionRequest_customerClass;
function CompletionRequest_customer() {
  if (CompletionRequest_customerClass === VOID) {
    class $ {
      constructor() {
        CompletionRequest_customer_instance = this;
        var tmp = this;
        tmp.m5g_1 = lazy(CompletionRequest_customer$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n5g_1 = lazy(CompletionRequest_customer$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o5g_1 = lazy(CompletionRequest_customer$annotations$delegate$lambda);
        this.p5g_1 = null;
        this.q5g_1 = 'null';
      }
      k20() {
        var tmp0 = this.m5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionRequest_customer$_get_name_$ref_2eeunr(), null);
        return tmp0.f2();
      }
      s5f(receiver) {
        return receiver.w5f_1;
      }
      m2j(receiver) {
        return this.s5f(receiver instanceof CompletionRequest() ? receiver : THROW_CCE());
      }
      r5g(receiver, value) {
        return receiver.z5f(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionRequest() ? receiver : THROW_CCE();
        return this.r5g(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionRequest_customer$_get_serializer_$ref_pd6sv2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionRequest_customer$_get_annotations_$ref_l4bbj2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionRequest_customer', VOID, VOID, [SerializableProperty()]);
    CompletionRequest_customerClass = $;
  }
  return CompletionRequest_customerClass;
}
var CompletionRequest_customer_instance;
function CompletionRequest_customer_getInstance() {
  if (CompletionRequest_customer_instance === VOID)
    new (CompletionRequest_customer())();
  return CompletionRequest_customer_instance;
}
function CompletionRequest_autoRelease$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function CompletionRequest_autoRelease$_get_name_$ref_r98exz() {
  return (p0) => p0.k20();
}
function CompletionRequest_autoRelease$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionRequest_autoRelease$_get_serializer_$ref_m3ck3k() {
  return (p0) => p0.j2j();
}
function CompletionRequest_autoRelease$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function CompletionRequest_autoRelease$_get_annotations_$ref_9bm66c() {
  return (p0) => p0.bz();
}
var CompletionRequest_autoReleaseClass;
function CompletionRequest_autoRelease() {
  if (CompletionRequest_autoReleaseClass === VOID) {
    class $ {
      constructor() {
        CompletionRequest_autoRelease_instance = this;
        var tmp = this;
        tmp.s5g_1 = lazy(CompletionRequest_autoRelease$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t5g_1 = lazy(CompletionRequest_autoRelease$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u5g_1 = lazy(CompletionRequest_autoRelease$annotations$delegate$lambda);
        this.v5g_1 = true;
        this.w5g_1 = 'true';
      }
      k20() {
        var tmp0 = this.s5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionRequest_autoRelease$_get_name_$ref_r98exz(), null);
        return tmp0.f2();
      }
      s5f(receiver) {
        return receiver.x5f_1;
      }
      m2j(receiver) {
        return this.s5f(receiver instanceof CompletionRequest() ? receiver : THROW_CCE());
      }
      x5g(receiver, value) {
        return receiver.z5f(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionRequest() ? receiver : THROW_CCE();
        return this.x5g(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionRequest_autoRelease$_get_serializer_$ref_m3ck3k(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionRequest_autoRelease$_get_annotations_$ref_9bm66c(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionRequest_autoRelease', VOID, VOID, [SerializableProperty()]);
    CompletionRequest_autoReleaseClass = $;
  }
  return CompletionRequest_autoReleaseClass;
}
var CompletionRequest_autoRelease_instance;
function CompletionRequest_autoRelease_getInstance() {
  if (CompletionRequest_autoRelease_instance === VOID)
    new (CompletionRequest_autoRelease())();
  return CompletionRequest_autoRelease_instance;
}
//region block: exports
export {
  prepareCompletionRequestFields as prepareCompletionRequestFields3v93uvsqk2qc1,
};
//endregion

//# sourceMappingURL=CompletionRequestFields.mjs.map
